// prettier-ignore
class PredictiveSearch extends SearchForm {
	constructor() {
		super();
		this.cachedResults = {};
		this.predictiveSearchResults = this.querySelector(
			"[data-predictive-search]",
		);
		this.allPredictiveSearchInstances =
			document.querySelectorAll("predictive-search");
		this.isOpen = false;
		this.abortController = new AbortController();
		this.searchTerm = "";
		this.body = document.querySelector("body");
		this.header = document.querySelector(".shopify-section-header");
		this.headerBottom = document.querySelector(".header__bottom");
		this.promoModal = document.querySelector(".search__modal");
		this.collectionList = document.querySelector(".template-404__collections");
		this.headerInput = document.querySelector(".header__search .search__input");

		// Define selectors for B2B filtering
		this.searchSelectors = {
			products: {
				container: '#predictive-search-results-products-list',
				items: '.collection-product-card',
				list: '.predictive-search__results-list_products',
				tab: '[data-type-target="products"]'
			},
			collections: {
				container: '.predictive-search__results-list_collections',
				items: '.collections-grid__card',
				list: '.predictive-search__results-list_collections',
				tab: '[data-type-target="collections"]'
			},
			pages: {
				container: '.predictive-search__results-list_pages',
				items: '.predictive-search__list-item[data-type="page"]',
				list: '.predictive-search__results-list_pages',
				tab: '[data-type-target="pages"]'
			},
			suggestions: {
				container: '.custom-search__suggestions-results-list',
				items: '.custom-search__suggestions-list-item'
			}
		};

		this.calcHeight();
		this.setupEventListeners();
	}

	calcHeight() {
		if (document.querySelector(".predictive-search")) {
			document.documentElement.style.setProperty(
				"--search-height",
				`calc(100vh - ${this.header.getBoundingClientRect().top}px)`,
			);
		}
	}

	setupEventListeners() {
		this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));
		this.input.addEventListener("focus", this.onFocus.bind(this));
		this.addEventListener("focusout", this.onFocusOut.bind(this));
		this.addEventListener("keyup", this.onKeyup.bind(this));
	}

	getQuery() {
		return this.input.value.trim();
	}

	_getCustomerFilter() {
		// Segment filtering is handled server-side in predictive-search.liquid
		// so products/collections without segment tags are included in results.
		return "";
	}

	onChange() {
		const newSearchTerm = this.getQuery();
		if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
			// Remove the results when they are no longer relevant for the new search term
			// so they don't show up when the dropdown opens again
			this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
		}

		// Update the term asap, don't wait for the predictive search query to finish loading
		this.updateSearchForTerm(this.searchTerm, newSearchTerm);

		this.searchTerm = newSearchTerm;

		if (!this.searchTerm.length) {
			this.close(true);
			return;
		}

		this.getSearchResults(this.searchTerm);
		if (this.getQuery().length) {
			this.hidePromoBlock();
		} else {
			this.showPromoBlock();
		}
	}

onFormSubmit(event) {
    event.preventDefault();

    if (this.querySelector('[aria-selected="true"] a') || event.submitter.classList.contains("card__link")) {
      return;
    }

    const searchInput = this.input;
    const dirtySearchTerm = searchInput.value.trim();
    const cleanSearchTerm = dirtySearchTerm.replace(/\s*\+?tag:[^\s]+/g, '').trim();
    const customerFilter = this._getCustomerFilter();

    let finalQuery = cleanSearchTerm;

    if (customerFilter) {
      finalQuery += `${customerFilter}`;
    }

    searchInput.value = cleanSearchTerm;

    const searchUrl = `${window.Shopify.routes.root}search?q=${finalQuery}`;
    window.location.href = searchUrl;
  }

	onFormReset(event) {
		super.onFormReset(event);
		if (super.shouldResetForm()) {
			this.searchTerm = "";
			this.abortController.abort();
			this.abortController = new AbortController();
			this.closeResults(true);
		}
	}

	onFocus() {
		const currentSearchTerm = this.getQuery();
		if (this.classList.contains("search-modal__form")) {
			if (this.headerBottom) {
				this.headerBottom.classList.add("header__bottom--visible");
			}
			if (this.promoModal) {
				this.promoModal.classList.remove("search__modal--hidden");
			}
			if (this.collectionList) {
				this.collectionList.classList.remove("hidden");
			}
		}

		if (!currentSearchTerm.length) {
			return;
		}

		if (this.searchTerm !== currentSearchTerm) {
			// Search term was changed from other search input, treat it as a user change
			this.onChange();
		} else if (this.getAttribute("results") === "true") {
			this.open();
			if (this.promoModal) {
				this.promoModal.classList.add("search__modal--hidden");
			}
			if (this.collectionList) {
				this.collectionList.classList.add("hidden");
			}
		} else {
			this.getSearchResults(this.searchTerm);
		}
	}

	onFocusOut() {
		if (this.classList.contains("search-modal__form")) {
			if (this.headerBottom) {
				this.headerBottom.classList.remove("header__bottom--visible");
			}
		}
		if (!this.classList.contains("search-modal__form")) {
			setTimeout(() => {
				if (!this.contains(document.activeElement)) this.close(true);
			});
		}
	}

	onBlur() {
		this.headerInput.blur();
	}

	onKeyup(event) {
		if (!this.getQuery().length) this.close(true);
		event.preventDefault();

		switch (event.code) {
			case "Enter":
				event.preventDefault();
				this.selectOption();
				break;
			case "Escape":
				this.close(true);
				this.closeResults(clearSearchTerm);
				if (this.getQuery().length) {
					this.hidePromoBlock();
				} else {
					this.showPromoBlock();
				}
				break;
		}
	}

	updateSearchForTerm(previousTerm, newTerm) {
		const searchForTextElement = this.querySelector(
			"[data-predictive-search-search-for-text]",
		);
		const currentButtonText = searchForTextElement?.innerText;
		if (currentButtonText) {
			if (
				currentButtonText.matchAll(new RegExp(previousTerm, "g")).length > 1
			) {
				// The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
				return;
			}
			const newButtonText = currentButtonText.replace(previousTerm, newTerm);
			searchForTextElement.innerText = newButtonText;
		}
		if (this.getQuery().length) {
			this.hidePromoBlock();
		} else {
			this.showPromoBlock();
		}
	}

	selectOption() {
		const selectedOption = this.querySelector(
			'[aria-selected="true"] a, button[aria-selected="true"]',
		);

		if (selectedOption) selectedOption.click();
	}

	getSearchResults(searchTerm) {
		const queryKey = searchTerm.replace(" ", "-").toLowerCase();
		this.setLiveRegionLoadingState();

		if (this.cachedResults[queryKey]) {
			this.renderSearchResults(this.cachedResults[queryKey]);
			this.clickSearchTabs();
			this.calcHeight();
			return;
		}

		if (this.promoModal && this.classList.contains("search-modal__form")) {
			this.promoModal.classList.add("search__modal--hidden");
		}

		if (this.collectionList) {
			this.collectionList.classList.add("hidden");
		}

		const customerFilter = this._getCustomerFilter();
		const finalSearchTerm = `${encodeURIComponent(
			searchTerm,
		)}${customerFilter}`;

		fetch(
			`${routes.predictive_search_url}?q=${finalSearchTerm}&section_id=predictive-search&resources[options][fields]=title,body,product_type,vendor,tag`,
			{ signal: this.abortController.signal },
		)
			.then((response) => {
				if (!response.ok) {
					var error = new Error(response.status);
					this.close();
					throw error;
				}
				return response.text();
			})
			.then((text) => {
				let resultsMarkup = new DOMParser()
					.parseFromString(text, "text/html")
					.querySelector("#shopify-section-predictive-search").innerHTML;
				const customerType = this.input.form?.dataset.customerType || "b2c";
				const extras =
					window.MG_B2BSearchExtras?.isB2BCustomer(customerType) &&
					window.MG_B2BSearchExtras.mergeIntoMarkup
						? window.MG_B2BSearchExtras.mergeIntoMarkup(
								resultsMarkup,
								customerType,
								searchTerm,
						  )
						: Promise.resolve(resultsMarkup);

				return extras.catch(() => resultsMarkup);
			})
			.then((resultsMarkup) => {
				if (this.searchTerm !== searchTerm) return;
				// Save bandwidth keeping the cache in all instances synced
				this.allPredictiveSearchInstances.forEach(
					(predictiveSearchInstance) => {
						predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
					},
				);
				this.renderSearchResults(resultsMarkup);
				this.clickSearchTabs();
				this.calcHeight();
				try {
					colorSwatches();
				} catch (err) {}
			})
			.catch((error) => {
				if (error?.code === 20) {
					// Code 20 means the call was aborted
					return;
				}
				this.close();
				throw error;
			});

		if (this.getQuery().length) {
			this.hidePromoBlock();
		} else {
			this.showPromoBlock();
		}
	}

	setLiveRegionLoadingState() {
		this.statusElement =
			this.statusElement || this.querySelector(".predictive-search-status");
		this.loadingText =
			this.loadingText || this.getAttribute("data-loading-text");

		this.setLiveRegionText(this.loadingText);
		this.setAttribute("loading", true);
	}

	setLiveRegionText(statusText) {
		this.statusElement.setAttribute("aria-hidden", "false");
		this.statusElement.textContent = statusText;

		setTimeout(() => {
			this.statusElement.setAttribute("aria-hidden", "true");
		}, 1000);
	}

	renderSearchResults(resultsMarkup) {
		this.predictiveSearchResults.innerHTML = resultsMarkup;
		this.setAttribute("results", true);

		// Get customer type from the results wrapper
		const resultsWrapper = this.querySelector('#predictive-search-results-groups-wrapper');
		const customerType = resultsWrapper?.dataset.customerType;

		// Filter products based on B2B rules
		// this.filterB2BResults(customerType);

		this.filterAndCleanKeywordResults(this.searchTerm);

		this.highlightQuery(this.searchTerm);
		this.setLiveRegionResults();
		this.open();
		if (this.promoModal && this.classList.contains("search-modal__form")) {
			this.promoModal.classList.add("search__modal--hidden");
		}
		if (this.collectionList) {
			this.collectionList.classList.add("hidden");
		}
	}

	filterB2BResults(customerType) {
		// Helper function to check if B2B item should be hidden
		const shouldHideB2BItem = (b2bType, title) => {
			if (customerType === 'b2c') {
				return title.includes('b2b') || b2bType;
			}

			if (customerType === 'b2b-retailer') {
				return b2bType === 'b2b-cosmetician' || (!b2bType && title.includes('cosmetician'));
			}

			if (customerType === 'b2b-cosmetician') {
				return b2bType === 'b2b-retailer' || (!b2bType && title.includes('retailer'));
			}

			return false;
		};

		// Helper function to get item title
		const getItemTitle = (item, type) => {
			if (type === 'collections') {
				return item.querySelector('.collections-grid__title')?.textContent?.toLowerCase() || '';
			}
			if (type === 'pages') {
				return item.querySelector('.card__text')?.textContent?.toLowerCase() || '';
			}
			return item.querySelector('.custom-search__suggestions__query')?.textContent?.toLowerCase() || '';
		};

		// Filter items in a container
		const filterItems = (container, itemSelector, type) => {
			if (!container) return;

			const items = container.querySelectorAll(itemSelector);
			items.forEach(item => {
				if (type === 'collections' || type === 'pages' ||
					(type === 'suggestions' && (item.dataset.type === 'collection' || item.dataset.type === 'page'))) {
					const b2bType = item.dataset.b2bType;
					const title = getItemTitle(item, type);
					if (shouldHideB2BItem(b2bType, title)) {
						item.remove();
					}
				}
			});

			// Remove empty container wrapper
			if (container.children.length === 0) {
				if (type === 'suggestions') {
					container.closest('.custom-search__suggestions-wrapper')?.remove();
				} else {
					container.closest('.predictive-search__pages-wrapper')?.remove();
				}
			}
		};

		// Apply filtering to all sections
		Object.entries(this.searchSelectors).forEach(([type, { container, items }]) => {
			const containerElement = this.querySelector(container);
			filterItems(containerElement, items, type);
		});

		this.updateTabsVisibility();
	}

	filterAndCleanKeywordResults(query) {
        if (!query) return;

        const keywordsRegex = /\s*\((KosmetikerInnen|Händler|Retailer|Cosmetician|B2B)\)/ig;

        const allItemsSelector = '.collection-product-card, .collections-grid__card, .custom-search__suggestions-list-item, .predictive-search__list-item[data-type="page"]';
        this.querySelectorAll(allItemsSelector).forEach(item => {
            let originalText;
            let elementToUpdate;

            if (item.matches('.collection-product-card')) {
                // Product card in grid
                const titleSource = item.querySelector('.visually-hidden');
                elementToUpdate = item.querySelector('.card__title a');
                if (!titleSource || !elementToUpdate) return;
                originalText = titleSource.textContent;
            } else if (item.matches('.custom-search__suggestions-list-item')) {
                // Suggestion item
                elementToUpdate = item.querySelector('.custom-search__suggestions__query');
                if (!elementToUpdate) return;
                originalText = elementToUpdate.textContent;
            } else {
                // Page or Collection item
                elementToUpdate = item.querySelector('.collections-grid__title, .card__text');
                if (!elementToUpdate) return;
                originalText = elementToUpdate.textContent;
            }

            const cleanedText = originalText.replace(keywordsRegex, '').trim();
            elementToUpdate.textContent = cleanedText;
        });
    }

	updateTabsVisibility() {
		Object.entries(this.searchSelectors).forEach(([type, { list, tab }]) => {
			// Skip suggestions as they don't have tabs
			if (type === 'suggestions' || !list || !tab) return;

			const listElement = this.querySelector(list);
			const tabElement = this.querySelector(tab);

			if ((!listElement || listElement.children.length === 0) && tabElement) {
				tabElement.remove();
			}
		});
	}

	clickSearchTabs() {
		const results = this.querySelectorAll(".predictive-search__results-list");
		if (results.length != 0) {
			results[0].classList.add("active");
			this.querySelector(".predictive-search__result-tab").classList.add(
				"active",
			);
			this.querySelectorAll(".predictive-search__result-tab").forEach((tab) => {
				tab.addEventListener("click", (event) => {
					event.preventDefault();
					const typeTarget = tab.dataset.typeTarget;
					this.querySelectorAll(".predictive-search__result-tab").forEach(
						(element) => {
							element.classList.remove("active");
						},
					);
					tab.classList.add("active");

					results.forEach((element) => {
						let resultsType = element.dataset.type;
						if (resultsType === typeTarget) {
							element.classList.add("active");
						} else {
							element.classList.remove("active");
						}
					});
				});
			});
		}
	}

	hidePromoBlock() {
		if (this.classList.contains("search-modal__form")) {
			if (this.promoModal) {
				this.promoModal.classList.add("search__modal--hidden");
			}
			if (this.collectionList) {
				this.collectionList.classList.add("hidden");
			}
		}
	}

	showPromoBlock() {
		if (this.classList.contains("search-modal__form")) {
			if (this.promoModal) {
				this.promoModal.classList.remove("search__modal--hidden");
			}
			if (this.collectionList) {
				this.collectionList.classList.remove("hidden");
			}
		}
	}

	setLiveRegionResults() {
		this.removeAttribute("loading");
		this.setLiveRegionText(
			this.querySelector("[data-predictive-search-live-region-count-value]")
				.textContent,
		);
	}

	open() {
		this.setAttribute("open", true);
		this.input.setAttribute("aria-expanded", true);
		this.isOpen = true;
		if (this.getQuery().length) {
			this.hidePromoBlock();
		} else {
			this.showPromoBlock();
		}
	}

	close(clearSearchTerm = false) {
		this.closeResults(clearSearchTerm);
		this.isOpen = false;
	}

	closeResults(clearSearchTerm = false) {
		if (clearSearchTerm) {
			this.input.value = "";
			this.removeAttribute("results");
		}
		const selected = this.querySelector('[aria-selected="true"]');

		if (selected) selected.setAttribute("aria-selected", false);

		this.input.setAttribute("aria-activedescendant", "");
		this.removeAttribute("loading");
		this.removeAttribute("open");
		this.input.setAttribute("aria-expanded", false);
		this.predictiveSearchResults.removeAttribute("style");
		if (this.getQuery().length) {
			this.hidePromoBlock();
		} else {
			this.showPromoBlock();
		}
	}

	highlightQuery(query) {
        if (query) {
            const titleElementsSelector = '.custom-search__suggestions__query, .collections-grid__title';
            this.querySelectorAll(titleElementsSelector).forEach(el => {
                const originalText = el.textContent;
                let resultHTML = '';
                let queryIndex = 0;

                for (let i = 0; i < originalText.length; i++) {
                    const char = originalText[i];
                    if (
                        queryIndex < query.length &&
                        char.toLowerCase() === query[queryIndex].toLowerCase()
                    ) {
                        resultHTML += `<span class="highlight__quary">${char}</span>`;
                        queryIndex++;
                    } else {
                        resultHTML += char;
                    }
                }
                el.innerHTML = resultHTML;
            });
        }
    }
}

customElements.define('predictive-search', PredictiveSearch);
